export { DesktopView } from './DesktopView';
export { MobileView } from './MobileView';

export const CONFIRMATION_STEPS_KEY_PREFIX = 'AppointmentsReserve.Steps.confirmation.';
